import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import RequestsList from './RequestsList';
import './styles.scss';

import { detectDevice } from './../../../../utilities/helpers';
import { useLanguage } from '../../../../context/LanguageContext';

const Requests = props => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  const [isSorting, setIsSorting] = useState(false);
  const [isAscending, setIsAscending] = useState(true)
  const [device, setDetectDevice] = useState(null)

  useEffect(() => {
    props.weightSorting(isAscending);
  },[isAscending])

  useEffect(() => { setDetectDevice(detectDevice()) }, [])

  const onSortStart = () => setIsSorting(true);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) props.reorderPreferences(oldIndex, newIndex);
    setIsSorting(false);
  };
  
  const onSorting = () => isAscending === true ? setIsAscending(false) : setIsAscending(true);

  return (
    <RequestsList
      readOnly={props.readOnly}
      title={props.title}
      preferences={props.preferences}
      lockAxis='y'
      useDragHandle={
        props.bidmode !== commonLabels.PRIORITY &&
        props.bidmode !== commonLabels.NONE
      }
      lockToContainerEdges
      totalEntries={props.preferences?.length}
      bidSession={props.bidSession}
      handleDeletePreference={props.handleDeletePreference}
      handleDeleteCombinedPreference={props.handleDeleteCombinedPreference}
      handleMovePreference={props.handleMovePreference}
      handleWeightEdit={props.handleWeightEdit}
      handleNext={props.handleNext}
      onSortStart={onSortStart}
      onSortEnd={onSortEnd}      
      helperClass='draggedElement'
      isSorting={isSorting}
      bidmode={props.bidmode}
      onSorting={onSorting}
      isAscending={isAscending}
      requestAll={props.requestAll}
      loadingBidTable={props.loadingBidTable}
      copyPreference={props.copyPreference}
      distance={device === 'desktop' ? 1 : null}
      pressDelay={device === 'tablet' ? 200 : null}
    />
  );
}

Requests.defaultProps = {
  readOnly: false,
  requestAll: false,
  loadingBidTable: false
};

Requests.propTypes = {
  title: PropTypes.string.isRequired,
  preferences: PropTypes.array,
  bidmode: PropTypes.string,
  reorderPreferences: PropTypes.func.isRequired,
  bidSession: PropTypes.object.isRequired,
  handleDeletePreference: PropTypes.func.isRequired,
  handleMovePreference: PropTypes.func.isRequired,
  handleWeightEdit: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  requestAll: PropTypes.bool,
  loadingBidTable: PropTypes.bool,
  copyPreference: PropTypes.func.isRequired,
};

export default Requests;
